<!-- This component hides/shows the associated-products section depending on the section settings & product availability online -->

<script>
import $dom from 'cash-dom';
import productCTAButtonsMixin from '../../mixins/productCTAButtonsMixin';

export default {
  mixins: [productCTAButtonsMixin],
  props: {
    product: {
      type: Object,
      required: true
    },
    metafields: {
      type: Object,
      required: true
    },
    sectionSettings: {
      type: Object,
      required: true
    }
  },
  computed: {
    findInStoreProduct() {
      return this.canFindInStore && !this.canAddProduct;
    }
  },
  mounted() {
    this.updateSection();
  },
  methods: {
    updateSection() {
      if (
        !this.sectionSettings.showForOfflineProducts &&
        this.findInStoreProduct
      ) {
        $dom('section.associated-products').css('display', 'none');
      } else {
        $dom('section.associated-products').css('display', 'block');
      }
    },
    afterLocationUpdate() {
      this.updateSection();
    }
  }
};
</script>
